var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 120,
    viewBox: "0 0 118 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9474 108.537C85.6896 108.537 107.368 86.8584 107.368 60.1162C107.368 33.374 85.6896 11.6951 58.9474 11.6951C32.2052 11.6951 10.5263 33.374 10.5263 60.1162C10.5263 86.8584 32.2052 108.537 58.9474 108.537Z",
    fill: "#67CE67"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10238_23532)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M59.4608 90.1947C78.3477 90.1947 93.6585 76.4012 93.6585 59.386C93.6585 42.3708 78.3477 28.5773 59.4608 28.5773C40.574 28.5773 25.2632 42.3708 25.2632 59.386C25.2632 76.4012 40.574 90.1947 59.4608 90.1947Z",
    fill: "#EB4B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1869 29.8096V91.4271C88.1869 92.7826 86.9558 93.8918 85.4511 93.8918H33.4706C31.9659 93.8918 30.7348 92.7826 30.7348 91.4271V29.8096C30.7348 28.454 31.9659 27.3449 33.4706 27.3449H45.7818V32.2743C45.7818 32.9521 46.3973 33.5067 47.1497 33.5067H37.5743V87.73H81.3474V33.5067H71.772C72.5243 33.5067 73.1399 32.9521 73.1399 32.2743V27.3449H85.4511C86.9558 27.3449 88.1869 28.454 88.1869 29.8096Z",
    fill: "#F1A33B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3474 33.5067V87.73H37.5743V33.5067H81.3474ZM70.4041 53.2242V48.2948C70.4041 47.6171 69.7885 47.0625 69.0362 47.0625H63.5646V42.1331C63.5646 41.4553 62.949 40.9007 62.1966 40.9007H56.725C55.9727 40.9007 55.3571 41.4553 55.3571 42.1331V47.0625H49.8855C49.1331 47.0625 48.5176 47.6171 48.5176 48.2948V53.2242C48.5176 53.902 49.1331 54.4566 49.8855 54.4566H55.3571V59.386C55.3571 60.0638 55.9727 60.6183 56.725 60.6183H62.1966C62.949 60.6183 63.5646 60.0638 63.5646 59.386V54.4566H69.0362C69.7885 54.4566 70.4041 53.902 70.4041 53.2242Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1399 27.3449V32.2743C73.1399 32.9521 72.5244 33.5066 71.772 33.5066H47.1497C46.3973 33.5066 45.7818 32.9521 45.7818 32.2743V27.3449C45.7818 26.6671 46.3973 26.1126 47.1497 26.1126H52.6213C52.6213 22.7113 55.6854 19.9508 59.4608 19.9508C63.2363 19.9508 66.3004 22.7113 66.3004 26.1126H71.772C72.5244 26.1126 73.1399 26.6671 73.1399 27.3449ZM61.5127 26.7287C61.5127 25.7059 60.5962 24.8802 59.4608 24.8802C58.3255 24.8802 57.409 25.7059 57.409 26.7287C57.409 27.7516 58.3255 28.5772 59.4608 28.5772C60.5962 28.5772 61.5127 27.7516 61.5127 26.7287Z",
    fill: "#D1D1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4041 48.2949V53.2242C70.4041 53.902 69.7885 54.4566 69.0362 54.4566H63.5646V59.386C63.5646 60.0638 62.949 60.6183 62.1967 60.6183H56.725C55.9727 60.6183 55.3571 60.0638 55.3571 59.386V54.4566H49.8855C49.1331 54.4566 48.5176 53.902 48.5176 53.2242V48.2949C48.5176 47.6171 49.1331 47.0625 49.8855 47.0625H55.3571V42.1331C55.3571 41.4553 55.9727 40.9008 56.725 40.9008H62.1967C62.949 40.9008 63.5646 41.4553 63.5646 42.1331V47.0625H69.0362C69.7885 47.0625 70.4041 47.6171 70.4041 48.2949Z",
    fill: "#F1A33B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4608 28.5772C60.594 28.5772 61.5127 27.7496 61.5127 26.7287C61.5127 25.7078 60.594 24.8802 59.4608 24.8802C58.3276 24.8802 57.409 25.7078 57.409 26.7287C57.409 27.7496 58.3276 28.5772 59.4608 28.5772Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1399 27.3449H85.4511C86.9558 27.3449 88.1869 28.454 88.1869 29.8096V91.4271C88.1869 92.7826 86.9558 93.8918 85.4511 93.8918H33.4706C31.9659 93.8918 30.7348 92.7826 30.7348 91.4271V29.8096C30.7348 28.454 31.9659 27.3449 33.4706 27.3449H45.7818",
    stroke: "#1C1C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6115 33.5067H81.3474V87.73H37.5743V33.5067H40.3101",
    stroke: "#1C1C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4041 70.4771H58.0929",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4041 77.8712H58.0929",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5176 70.4771H51.2534",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5176 77.8712H51.2534",
    stroke: "#F2F2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1497 33.5066C46.3973 33.5066 45.7818 32.9521 45.7818 32.2743V27.3449C45.7818 26.6671 46.3973 26.1126 47.1497 26.1126H52.6213C52.6213 22.7113 55.6854 19.9508 59.4608 19.9508C63.2363 19.9508 66.3004 22.7113 66.3004 26.1126H71.772C72.5244 26.1126 73.1399 26.6671 73.1399 27.3449V32.2743C73.1399 32.9521 72.5244 33.5066 71.772 33.5066H47.1497Z",
    stroke: "#1C1C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5646 47.0625V42.1331C63.5646 41.4553 62.949 40.9008 62.1967 40.9008H56.725C55.9727 40.9008 55.3571 41.4553 55.3571 42.1331V47.0625H49.8855C49.1331 47.0625 48.5176 47.6171 48.5176 48.2949V53.2242C48.5176 53.902 49.1331 54.4566 49.8855 54.4566H55.3571V59.386C55.3571 60.0638 55.9727 60.6183 56.725 60.6183H62.1967C62.949 60.6183 63.5646 60.0638 63.5646 59.386V54.4566H69.0362C69.7885 54.4566 70.4041 53.902 70.4041 53.2242V48.2949C70.4041 47.6171 69.7885 47.0625 69.0362 47.0625H63.5646Z",
    stroke: "#1C1C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10238_23532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.3954,
    height: 75.7895,
    fill: "white",
    transform: "translate(25.2632 19.0266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bd5e6b7e5deefc3ffe3736749bd4a651.svg";
export { ForwardRef as ReactComponent };